import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import {FirstQuestion} from './components/FirstQuestion';
import {SecondQuestion} from './components/SecondQuestion';
import {ThirdQuestion} from './components/ThirdQuestion';
import {FourthQuestion} from './components/FourthQuestion';
import {FifthQuestion} from "./components/FifthQuestion";
import {ThankYouScreen} from "./components/ThankYouScreen";

export default function Routes() {
    return (
        <BrowserRouter basename="/form">
            <Switch>
                <Route path="/" exact component={ FirstQuestion } />
                <Route path="/second" component={ SecondQuestion } />
                <Route path="/third" component={ ThirdQuestion } />
                <Route path="/fourth" component={ FourthQuestion } />
                <Route path="/fifth" component={ FifthQuestion } />
                <Route path="/thankscreen" component={ ThankYouScreen } />
            </Switch>
        </BrowserRouter>
    )
}